import { ApolloError } from "@apollo/client/errors";

import { getGraphQLErrors } from "@utils/graphQLErrorType";

const knownErrorTypes = [
  "Unauthorized",
  "UnauthorizedError",
  "ForbiddenError",
  "InvalidStateError",
  "NotFoundError",
  "PaymentRetrialError",
];

export function getErrorMessageFromApolloError(
  apolloError: ApolloError
): string | undefined {
  const error = getGraphQLErrors(apolloError).find(({ errorType }) =>
    knownErrorTypes.includes(errorType ?? "")
  );
  const errorType = error?.errorType;

  if (errorType === "Unauthorized" || errorType === "UnauthorizedError") {
    return "You are not authorized to perform this action.";
  }

  return error?.message;
}
